import React from 'react';


import TextField from '@material-ui/core/TextField';

import { Grid } from '@material-ui/core';

const renderTextFieldOtp = props => {
    const { input, label, type, meta: { touched, error }, onKeyPress, autoFocus } = props
    /*const [values, setValues] = useState({
        numberformat: '' + valueData ,
    }); */
    
        return <div>
                  <Grid container spacing={1} justify="center" alignItems="center" direction="column" >
                    <Grid item xs={12} md={12}>
                      <span style={{color:'white'}}>{label}</span>
                    </Grid>
                  </Grid>
                    <TextField
                        {...input}
                        type={!type ? "text" : type}
                        variant="standard"
                        margin="none"
                        autoComplete="off"
                        fullWidth
                        style={{backgroundColor: 'white', borderRadius: '0px'}}
                        InputLabelProps= {
                            {
                            style: { color: '#fffffe', fontSize : "120%"}
                            }
                        }
                        onKeyUp={ onKeyPress }
                        name={label}
                        id={label}
                        label={''}
                        autoFocus = {autoFocus}
                        inputProps = {{
                            style : {
                            borderLeft: '4px solid rgba(255, 198, 0)',
                            margin : "5px",
                            paddingLeft : "5px"
                            }
                        }}
                        InputProps={{
                            style : {
                            height : "45px"
                            }
                        }}
                        // ref={withFocus && (txt => { this.txt = txt;} ) }
                    />
                    {touched && error && <span style = {{ color: 'red'}}>{error}</span>}
                    </div>
}

export default renderTextFieldOtp
